import { useQuery } from "@tanstack/react-query";
import { getRoomsWithIntegrations } from "../../rooms/get-rooms-with-integrations.api.services";

export const getRoomsWithIntegrationsKey = (ownerId?: string) => [
  "rooms",
  "with-integrations",
  ownerId ?? "self",
];

export function useQueryGetRoomsWithIntegrations(ownerId?: string, enabled = true) {
  const {
    data: rooms = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: getRoomsWithIntegrationsKey(ownerId),
    queryFn: () => getRoomsWithIntegrations(ownerId),
    enabled,
  });

  return {
    rooms,
    isLoading,
    isError,
  };
}
